(() => {
  function selectThumbnail(thumbnail) {
    const card = thumbnail.closest('.product-card-wrapper');
    if (!card) return;

    const mainImage = card.querySelector('.goat-card-main-image');
    const imageSrc = thumbnail.dataset.imageSrc;
    const productUrl = thumbnail.dataset.productUrl;

    if (mainImage && imageSrc) {
      mainImage.removeAttribute('srcset');
      mainImage.src = imageSrc;
      mainImage.alt = thumbnail.dataset.imageAlt || mainImage.alt;
    }

    if (productUrl) {
      card.querySelectorAll('a.full-unstyled-link').forEach((link) => {
        link.href = productUrl;
      });
    }

    card.classList.add('is-goat-media-selected');
    card.querySelectorAll('[data-goat-card-thumbnail]').forEach((item) => {
      const selected = item === thumbnail;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-current', selected ? 'true' : 'false');
    });
  }

  document.addEventListener('mouseover', (event) => {
    const thumbnail = event.target.closest('[data-goat-card-thumbnail]');
    if (thumbnail) selectThumbnail(thumbnail);
  });

  document.addEventListener('focusin', (event) => {
    const thumbnail = event.target.closest('[data-goat-card-thumbnail]');
    if (thumbnail) selectThumbnail(thumbnail);
  });

  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-goat-card-thumbnail]');
    if (!thumbnail) return;
    event.preventDefault();
    selectThumbnail(thumbnail);
  });
})();
